import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";
import {desksApi} from "@/store/api/v1/desks";

export const paymentsApi = createApi({
    reducerPath: 'paymentsApi',
    tagTypes: ['payments'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getPayments: build.query({
            query: (data) => ({
                url: api.payments.getPayments(),
                method: 'GET',
                params: data
            }),
            serializeQueryArgs: ({endpointName, queryArgs}) => {
                return [endpointName, queryArgs?.location_id]
            },
            merge: (currentCache, newItems, {arg}) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({currentArg, previousArg}) => {
                return currentArg !== previousArg;
            },
            providesTags: ['payments'],
        }),
        findPayment: build.query({
            query: ({id, ...data}) => ({
                url: api.payments.findPayment(id),
                method: 'GET',
                params: data
            }),
        }),
        refundPayment: build.mutation({
            query: ({id, ...data}) => ({
                url: api.payments.refundPayment(id),
                method: 'POST',
                body: data
            }),
            async onQueryStarted(patch, {dispatch, queryFulfilled}) {
                try {
                    await queryFulfilled
                    dispatch(
                        paymentsApi.util.updateQueryData('getPayments', patch, (draft) => {
                            const index = draft?.findIndex((payment) => payment.id === patch.id);
                            if (index !== -1) {
                                draft[index] = {
                                    ...draft[index],
                                    'refunded_amount': draft[index]?.refunded_amount + patch.amount,
                                    'status': 'refunded'
                                }
                            }
                        })
                    );
                } catch (e) {
                    console.error('Refund failed:', e)
                }
            },
        }),
        updatePayment: build.mutation({
            query: ({id, ...data}) => ({
                url: api.bookings.payBooking(id),
                method: 'POST',
                body: data
            }),
            async onQueryStarted(patch, {dispatch, queryFulfilled}) {
                const locationId = patch.location_id;
                dispatch(
                    paymentsApi.util.invalidateTags(['payments'])
                );

                dispatch(
                    paymentsApi.endpoints.getPayments.initiate(
                        {skip: 0, location_id: locationId},
                        {forceRefetch: true}
                    )
                );

                try {
                    await queryFulfilled;
                    dispatch(desksApi.util.invalidateTags(['desks', 'desk-transactions']));
                } catch {}
            }
        }),
    })
})

export const {useLazyGetPaymentsQuery, useLazyFindPaymentQuery, useRefundPaymentMutation} = paymentsApi
